/**
 * @generated SignedSource<<f4492cf9e2df993143f999fbe77898ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ManageWalletsModalFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ManageWalletsFragment">;
  readonly " $fragmentType": "ManageWalletsModalFragment";
};
export type ManageWalletsModalFragment$key = {
  readonly " $data"?: ManageWalletsModalFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ManageWalletsModalFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ManageWalletsModalFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ManageWalletsFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "d16ce6a547707d5f91c20df2a3ac1bd3";

export default node;
